import { render, staticRenderFns } from "./accessories-icon.vue?vue&type=template&id=2f10a656&"
import script from "./accessories-icon.vue?vue&type=script&lang=js&"
export * from "./accessories-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports